const base64ToBlob = (base64OrDataUrl) => {
    const byteCharacters = atob(base64OrDataUrl);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: "application/pdf" });
};
const generateDownloadUrl = (pdfOrBlob) => {
    let blob;
    if (typeof pdfOrBlob === "string") {
        blob = base64ToBlob(pdfOrBlob);
    }
    else {
        blob = pdfOrBlob;
    }
    const url = URL.createObjectURL(blob);
    return url;
};
export default generateDownloadUrl;
//# sourceMappingURL=helpers.js.map